<template>
  <pt-sell-order-form class="pt-sell-order-form__page"></pt-sell-order-form>
</template>

<script>
import PtSellOrderForm from 'cps/adult-sell-order/pt-sell-order-form/withData'
export default {
  name: 'pt-sell-order-form__view',
  components: {
    'pt-sell-order-form': PtSellOrderForm
  }
}
</script>
